module.exports = __webpack_public_path__ + "img/brodcast-maxim-mobile.15281606.jpg";